/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Component, OnInit, EventEmitter, Output, Input} from '@angular/core';
import {Router} from '@angular/router';

declare var $: any;

@Component({
  selector: 'ef-simple-success-error-dialog-box',
  templateUrl: './simple-success-error-dialog-box.component.html'
})
export class SimpleSuccessErrorDialogComponent implements OnInit {

  @Output() 
  dialogClosed = new EventEmitter<void>();

  title: string = null;
  message: string = null;
  errorVisible: boolean = false;
  successVisible: boolean = false;
  visible: boolean = false;

  constructor(
    private mRouter: Router
  ) {}

  ngOnInit(): void {}

  showErrorDialog(title: string, message: string): void {
    this.title = title;
    this.message = message;
    this.visible = true;
    this.errorVisible = true;
  }

  showSuccessDialog(title: string, message: string): void {
    this.title = title;
    this.message = message;
    this.visible = true;
    this.successVisible = true;
  }  

  hide(): void {
    this.visible = false;
    this.dialogClosed.emit();
  }

}

// Exporting this Constant to be used in other components

export const ERROR_DIALOG_TITLE = 'Oops..Encountered an Error !!';
export const SUCCESS_DIALOG_TITLE = 'Success !!';
